import React, {useState} from "react";
import {
  SlTabGroup,
  SlTab,
  SlTabPanel,
} from "@shoelace-style/shoelace/dist/react";
import ClientTrackerMonth from "./ClientTrackerMonth";
import ClinetWiseRevenueMonth from "./ClinetWiseRevenueMonth";
import RevenueSummary from "./RevenueSummary";
import PlanningSheetRollingMonth from "./PlanningSheetRollingMonth";
import AccountConversionRollingAverage from "./AccountConversionRollingAverage";
import AccountManagementTracking from "./AccountManagementTracking";

function MonthlyReports() {
  const [currentTab, setCurrentTab] = useState("revenue");

  const handleTabChange = (tabName) => {
    setCurrentTab(tabName);
  };

  return (
    <>
      <h5>Monthly Reports</h5>
      <SlTabGroup>
        <SlTab slot="nav" panel="revenue" onClick={()=>{handleTabChange('revenue')}}>Revenue Summary</SlTab>
        <SlTab slot="nav" onClick={()=>{handleTabChange('client-tracker')}} panel="client-tracker">Client Tracker Month</SlTab>
        <SlTab slot="nav" panel="clientwise-revenue" onClick={()=>{handleTabChange('clientwise-revenue')}}>Clinet Wise Revenue</SlTab>
        <SlTab slot="nav" panel="Account-conversion" onClick={()=>{handleTabChange('Account-conversion')}}>Account Conversion Rolling Average</SlTab>
        <SlTab slot="nav" panel="Account-management" onClick={()=>{handleTabChange('Account-management')}}>Account Management Tracking</SlTab>
        <SlTab slot="nav" panel="planning" onClick={()=>{handleTabChange('planning')}}>Planning Sheet Rolling Month</SlTab>
        <SlTabPanel name="client-tracker">
            {currentTab === 'client-tracker' && <ClientTrackerMonth />}
        </SlTabPanel>
        <SlTabPanel name="clientwise-revenue">
          {currentTab === 'clientwise-revenue' && <ClinetWiseRevenueMonth />}
          </SlTabPanel>
        <SlTabPanel name="revenue">
          {currentTab === 'revenue' && <RevenueSummary />}
          </SlTabPanel>
          <SlTabPanel name="planning">
            {currentTab === 'planning' && <PlanningSheetRollingMonth />}
          </SlTabPanel>
        <SlTabPanel name="Account-conversion">
          {currentTab === 'Account-conversion' && <AccountConversionRollingAverage/>}
        </SlTabPanel>
        <SlTabPanel name="Account-management">
            {currentTab === 'Account-management' && <AccountManagementTracking />}
        </SlTabPanel>
      </SlTabGroup>
    </>
  );
}

export default MonthlyReports;
